export const SET_COUNTRIES = "Setzt alle Countries";
